<template>
  <div class="newsletter-form">
    <form action="#">
      <div class="form-group">
        <div class="input-wrapper">
          <input v-floating-label id="emailAddress" name="emailAddress" v-model="newsletterEmail" type="email" class="form-control" @change="$v.newsletterEmail.$touch()">
          <label for="emailAddress">Email address</label>
          <div class="field-error" v-if="$v.newsletterEmail.$dirty && !$v.newsletterEmail.required">Email is required</div>
          <div class="field-error" v-if="$v.newsletterEmail.$dirty && !$v.newsletterEmail.email">The email address is invalid</div>
        </div>

        <button type="submit" class="floating-submit"><i class='uil uil-arrow-right'></i></button>
      </div>
    </form>
  </div>
</template>

<script>
import {
  required,
  email
} from 'vuelidate/lib/validators'

export default {
  name: 'newsletter-form',
  data() {
    return {
      newsletterEmail: ''
    }
  },
  validations: {
    newsletterEmail: {
      required,
      email
    }
  }
}
</script>
